import { alpha } from '@mui/material';
import { palette } from '@client/theme/colors';
import { theme } from '@client/theme/constants';
import { typography } from '@client/theme/typography';
import type { ThemeOptions } from '@mui/material';

const List: ThemeOptions['components'] = {
  MuiList: {
    styleOverrides: {
      padding: {
        paddingBottom: 0,
        paddingTop: 0,
      },
    },
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        fontSize: typography.fontSize,

        '&.Mui-selected': {
          backgroundColor: palette.info.xlight,
        },

        '&.Mui-focusVisible': {
          backgroundColor: 'transparent',
        },
      },
      secondaryAction: {
        paddingRight: theme.spacing(8),
      },
      button: {
        '&:hover': {
          backgroundColor: alpha(palette.info.dark, 0.05),
        },
      },
      padding: {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
      },
      dense: {
        padding: 0,

        '& + .MuiListItem-dense': {
          marginTop: theme.spacing(1),
        },
      },
      divider: {
        borderBottomColor: palette.divider,
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: 'auto',
        marginRight: theme.spacing(1),
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        borderRadius: '50%',
        boxShadow: 'none',
        color: palette.grey[50],
        minWidth: 34,
        minHeight: 34,
        fontSize: 22,
        padding: 6,
        marginRight: theme.spacing(1),

        '& > svg': {
          fontSize: 22,
        },
      },
    },
  },
  MuiListItemSecondaryAction: {
    styleOverrides: {
      root: {
        '& svg': {
          color: palette.text.disabled,
        },
      },
    },
  },
  MuiListItemText: {
    defaultProps: {
      primaryTypographyProps: {
        variant: 'body1',
        color: 'textPrimary',
      },
      secondaryTypographyProps: {
        variant: 'caption',
        color: 'textSecondary',
      },
    },
    styleOverrides: {
      root: {
        marginTop: theme.spacing(1 / 2),
        marginBottom: theme.spacing(1 / 2),
      },
      secondary: {
        '& > svg': {
          fontSize: 15,
          marginRight: theme.spacing(1 / 2),
        },
      },
    },
  },
};

export default List;
